import React from 'react';
import { TreeNodeType } from '../../../../../lib/types/types';
import { assignIdsToStruc } from '../../../../../utils/helper';
import AbschlussZwischenBericht, { getFormStrucAbschlussZwischenBericht } from './content/AbschlussZwischenBericht';
import Abweichung, { formStrucAbweichung } from './content/Abweichung';
import Beschaeftigungswirkung, { formStrucBeschaeftigungswirkung } from './content/Beschaeftigungswirkung';
import Betrag, { formStrucBetrag } from './content/Betrag';
import Interessensbekundungen, { formStrucInteressensbekundungen } from './content/Interessensbekundungen';
import Oeffentlichkeitsarbeit, { getFormStrucOeffentlichkeitsarbeit } from './content/Oeffentlichkeitsarbeit';
import Projekterfolge, { formStrucProjekterfolge } from './content/Projekterfolge';
import Projektergebnisse, { getFormStrucProjektergebnisse } from './content/Projektergebnisse';
import SchutzRechte, { formStrucSchutzRechte } from './content/SchutzRechte';
import Wissenschaftlische, { getFormStrucWissenschaftlische } from './content/Wissenschaftlische';
import ZusammenArbeit, { formStrucZusammenArbeit } from './content/ZusammenArbeit';

export const TreeStructureZwischenbericht = (application: any) => {
	const treeNodes: TreeNodeType[] = [
		{ label: 'Projektergebnisse', content: <Projektergebnisse />, formStruc: getFormStrucProjektergebnisse(application) },
		{ label: 'Abweichung', content: <Abweichung />, formStruc: formStrucAbweichung },
		{ label: 'Beitrag', content: <Betrag />, formStruc: formStrucBetrag },
		{ label: 'Zusammenarbeit', content: <ZusammenArbeit />, formStruc: formStrucZusammenArbeit },
		{
			label: 'Öffentlichkeitarbeit',
			content: <Oeffentlichkeitsarbeit />,
			formStruc: getFormStrucOeffentlichkeitsarbeit(application),
		},
		{ label: 'Projekterfolge', content: <Projekterfolge />, formStruc: formStrucProjekterfolge },
		{
			label: 'Beschaeftigungswirkung',
			content: <Beschaeftigungswirkung />,
			formStruc: formStrucBeschaeftigungswirkung(application),
		},
		{
			label: 'Wissenschaftliche Arbeiten',
			content: <Wissenschaftlische />,
			formStruc: getFormStrucWissenschaftlische(application),
		},
		{ label: 'Schutzrechte', content: <SchutzRechte />, formStruc: formStrucSchutzRechte(application) },
		{
			label: 'Interressensbekundungen',
			content: <Interessensbekundungen />,
			formStruc: formStrucInteressensbekundungen(application),
		},
		{ label: 'Abschluss', content: <AbschlussZwischenBericht />, formStruc: getFormStrucAbschlussZwischenBericht() },
	];

	return assignIdsToStruc(treeNodes);
};
